import { PlayerConfig } from "./media_config.js";
import { Media } from "./media_player.types";

export class VideoConfig extends PlayerConfig {
  protected readonly uiMode: "audio" | "video" = "video";

  public constructor(media: Media) {
    super(media);
    this.doAutoplay = this.checkForAutoplay(
      media.isLeadContent,
      media.isVideoArticle,
    );
  }

  // A video may only play automatically if it is located in the lead area of a video
  // article and the user has navigated to the page via an internal link. If a user
  // accesses the page via an external source such as Google, the video may not start
  // automatically.
  checkForAutoplay = (isLeadContent: boolean, isVideoArticle: boolean) => {
    if (!isLeadContent || !isVideoArticle) {
      return false;
    }
    const referrerUrl = document.referrer
      ? new URL(document.referrer)
      : undefined;
    return referrerUrl?.origin === window.location.origin;
  };
}
